module.exports = new __parcel__URL__("report-velocity.af32d9e6.svg").toString();